import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/25_card_back_ladybug/25_card_back_ladybug"
 * Contains 1 texture(s)
 */
export class CardsBacks25CardBackLadybugAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/25_card_back_ladybug/25_card_back_ladybug';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '25_ladybug.png'
    ] as const;
}
